export class EditProfilePhotoController {
  constructor($scope, $rootScope, $http, toastr, UserService, PhotoService) {
    $scope.vm = this;
    $scope.imageEditorAction = {};
    $scope.imageUpload = '';
    $scope.toastr = toastr;
    $scope.file = '';

    $scope.avatar = {
      width: "370",
      height: "493"
    };

    this.scope = $scope;
    this.rootScope = $rootScope;
    this.http = $http;
    this.UserService = UserService;
    this.PhotoService = PhotoService;

    // Display inital data
    this.scope.step = 1;

    this.scope.activityIndicatorOn = function () {
      $('<div id="imagelightbox-loading"><div></div></div>').appendTo('body');
    };

    this.scope.activityIndicatorOff = function () {
      $('#imagelightbox-loading').remove();
    };

    this.scope.overlayOn = function () {
        $('<div id="imagelightbox-overlay"></div>').appendTo('body');
    };

    this.scope.overlayOff = function () {
      $('#imagelightbox-overlay').remove();
    };

    this.init();

  }

  init() {
    this.UserService.getCurrentUser()
      .then((response) => { let user = response.data;
        this.rootScope.currentUserProfile = user.data;
      })
      .catch((response) => { let error = response.data;
        console.log(error);
      });
  }

  addAlbumPhoto(file) {
    this.scope.file = file;

    if (this.scope.file && this.scope.file.$error) {
      if(this.scope.file.$error == "maxSize") {
        this.scope.step = 1;
        this.scope.toastr.warning("Too big. El tamaño máximo es de 5 MB");
      }
      else {
        this.scope.step = 1;
        this.scope.toastr.warning("Imagen de error");
      }

      this.scope.file = null;
      return;
    }

    var reader = new window.FileReader();

    reader.onload = () => {
      var image = new Image();
      image.onload = () => {
        if (image.width < 370 || image.height < 493) {
          this.scope.toastr.warning('Tu foto debe ser por lo menos de 370x493');
          this.scope.step = 1;
          this.scope.file = undefined;

          return;
        }

        this.scope.step = 2;
        this.scope.file.width = image.width;
        this.scope.file.height = image.height;

      };

      image.src = reader.result;
      this.scope.file.dataUrl = image.src;
    };

    reader.readAsDataURL(file);

    this.scope.rotateRight = () => {
      if (this.checkImageLoaded()) {
        this.scope.imageEditorAction.rotateRight();
      }
    };

    this.scope.rotateLeft = () => {
      if (this.checkImageLoaded()) {
        this.scope.imageEditorAction.rotateLeft();
      }
    };

    this.scope.zoomIn = () => {
      if (this.checkImageLoaded()) {
        this.scope.imageEditorAction.zoomIn();
      }
    };

    this.scope.zoomOut = () => {
      if (this.checkImageLoaded()) {
        this.scope.imageEditorAction.zoomOut();
      }
    };

    this.scope.fit = () => {
      if (this.checkImageLoaded()) {
        this.scope.imageEditorAction.fit();
      }
    };

  };

  checkImageLoaded() {
    if (this.scope.file == '') {
      this.scope.toastr.warning('Debes cargar tu foto primero');
      return false;
    }
    if (this.scope.saving === true) {
      this.scope.toastr.info('Aún estamos procesando tu foto, por favor espera un momento');
      return false;
    }
    if (this.id > 0) {
      this.scope.toastr.info('Tu foto ya se encuentra cargada y se encuentra en proceso de validación.');
      return false;
    }
    return true;
  };

  uploadPhoto() {
    if (this.checkImageLoaded()) {
      var image = this.scope.file;

      if (image == "") {
        this.scope.toastr.warning('Debes cargar tu foto antes de subirla');
        return;
      }

      var data = this.scope.imageEditorAction.getData();

      // The editor has no crop data until the photo is decoded and fitted.
      if (!data) {
        this.scope.toastr.info('Aún estamos procesando tu foto, por favor espera un momento');
        return;
      }

      this.scope.saving = true;
      this.scope.overlayOn();
      this.scope.activityIndicatorOn();

      var params = {
        width: this.scope.file.width,
        height: this.scope.file.height,
        file: this.scope.file,
        name: this.scope.file.name,
        type: this.scope.file.type,
        cropConfig: data,
        id: this.rootScope.currentUserProfile._id
      };

      this.PhotoService.changeAvatar(params)
        .then((response) => { let data = response.data;
          this.scope.saving = false;
          if (data.success === true) {
            this.scope.step = 3;
            Object.assign(this.rootScope.currentUserProfile, data);
            this.scope.activityIndicatorOff();
            this.scope.overlayOff();
            this.UserService.getCurrentUser()
              .then((response) => { let result = response.data;
                this.rootScope.currentUserProfile = result.data;
              })
              .catch((response) => { let err = response.data;
                console.log(err);
              });
          } else {
            this.scope.toastr.warning(data.message);
          }

        }).catch((response) => { let err = response.data;
          this.scope.saving = false;
          this.scope.activityIndicatorOff();
          this.scope.overlayOff();
          this.scope.toastr.error('error photo upload');
          console.log(err);
        });
    }
  }
}
